import * as React from "react";
const SvgGables = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 1" }, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M20 6.5c-8.79-4.39-9.33-4.2-9.77-4.06h-.09l-8 4a1 1 0 0 0-.55.89v4a.8.8 0 0 0 0 .27v.05a1.3 1.3 0 0 0 .13.26l.05.07a.9.9 0 0 0 .23.2L12.5 18v.9l-1 .5s0 3.79 3.3 1.47l7.2-3.58a1 1 0 0 0 .55-.9v-4c-.05-.47-.12-4.65-2.55-5.89m-6.9 9a.9.9 0 0 0-.35.32l-8-4.39 5.77-2.93 8.66 3.94Zm7.28-4.74-8.83-4v-2c1.09.44 3.26 1.4 7.55 3.55a3.55 3.55 0 0 1 1.23 2.45ZM3.5 8l6-3v1.78l-6 3Zm17 7.77-5.94 3h-.06v-1.38a1 1 0 0 0 0-.16 1 1 0 0 0 0-.15l6.06-3Z",
	style: { fill: "currentColor" }
}))));
export default SvgGables;
